<template>
  <DialogButtonWithTooltip
    ref="dateModal"
    tooltipTop
    modalWidth="550px"
    :triggerButtonProps="{
      small: true,
      outlined: true,
      color: 'var(--goe-fontColor-darkish)'
    }"
    smallTriggerIcon
    iconName="mdi-calendar"
    :tooltipText="
      disabled ? 'Verschiebung nicht möglich' : 'Kündigungsdatum verschieben'
    "
    confirmButtonText="Kündigungsdatum verschieben"
    confirmButtonColor="warning"
    :confirmButtonDisabled="disabled || !isInputValid"
    :disabled="disabled"
    :loading="submitting"
    :closeOnSubmit="false"
    persistent
    @onCancel="
      () => {
        newTerminationDate = null;
      }
    "
    @onAction="saveTerminationDate()"
  >
    <template v-slot:triggerButtonText> Terminverschiebung </template>
    <template v-slot:dialogTitle> Kündigungsdatum verschieben </template>
    <template v-slot:dialogText>
      <v-row class="mt-4 mb-2 mx-2">
        <DatePicker
          label="Neues Kündigungsdatum"
          :disabled="disabled"
          :minDate="minTerminationDate"
          :value="newTerminationDate"
          :disableWeekend="false"
          :disableHolidays="false"
          :blacklist="[processRecallDate.toString()]"
          @input="updateTerminationDate($event)"
          @inputValidated="datePickerValidated"
        />
      </v-row>
    </template>
  </DialogButtonWithTooltip>
</template>
<script>
import { HTTP } from '@/main/httpClient.js';

import DialogButtonWithTooltip from '@/components/elements/DialogButtonWithTooltip.vue';
import DatePicker from '@/components/elements/DatePicker.vue';
import NotificationObject from '@/main/NotificationObject.js';

import { LocalDate } from '@js-joda/core';
import { CAMUNDA } from '@/main/constants.js';

export default {
  name: 'ModifyTerminationDate',
  components: {
    DialogButtonWithTooltip,
    DatePicker
  },
  props: {
    processData: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    newTerminationDate: '',
    submitting: false,
    isInputValid: false
  }),
  computed: {
    minTerminationDate() {
      return LocalDate.now().toString();
    },
    processRecallDate() {
      const date = this.processData.recallDate?.split('T')[0];
      return date ? LocalDate.parse(date) : undefined;
    },
    terminationTimerJob() {
      const jobs = this.processData.currentJobs;
      if (!Array.isArray(jobs) || jobs.length === 0) return false;
      return jobs.find(
        (j) =>
          j.jobHandlerConfiguration === CAMUNDA.WAIT_FOR_TERMINATION_TIMER_ID
      );
    },
    disabled() {
      return !this.terminationTimerJob;
    }
  },
  mounted() {
    this.newTerminationDate = this.processRecallDate.toString();
  },
  methods: {
    datePickerValidated(result) {
      this.isInputValid = result;
    },
    async saveTerminationDate() {
      this.submitting = true;

      const body = {
        job: this.terminationTimerJob,
        processInstanceId: this.processData.processInstanceId,
        newTerminationDate: this.newTerminationDate
      };

      HTTP.patch('contracts/withdrawal/modifyTerminationDate', body)
        .then(() => {
          this.showMessage('Der Termin wurde erfolgreich verschoben');
          this.$emit('onSuccess');
        })
        .catch(() => {
          this.showError(
            'Die Kündigung konnte nicht verschoben werden, es ist ein Fehler aufgetreten'
          );
        })
        .finally(() => {
          this.submitting = false;
          this.$refs.dateModal.$data.modalActive = false;
        });
    },
    updateTerminationDate(newDate) {
      this.newTerminationDate = newDate;
    },
    showError: function (message) {
      this.showMessage(message, 'error');
    },
    showMessage: function (description, type = 'success') {
      this.$store.commit(
        'addNotification',
        new NotificationObject(type, description)
      );
    }
  }
};
</script>
